import { render, staticRenderFns } from "./SalesTaxConfiguration.vue?vue&type=template&id=80272e1c&scoped=true"
import script from "./SalesTaxConfiguration.vue?vue&type=script&lang=js"
export * from "./SalesTaxConfiguration.vue?vue&type=script&lang=js"
import style0 from "./SalesTaxConfiguration.vue?vue&type=style&index=0&id=80272e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80272e1c",
  null
  
)

export default component.exports